import * as React from "react";
import { connect } from "react-redux";
import UhaulStore from "../CustomRedux/UhaulStore";
import { updateCustomerDataList } from "./Actions/CRMActions";
import { GetSearchTerm } from "../RefreshStats";
import { Box, Text } from "@twilio/flex-ui/node_modules/@twilio-paste/core";

export class CMGTCustomerInfo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            cannedMessages: [],
            attributes: null,
            newProps: { ...this.props },
            htmlString: ""
        };        
    }

    state = this.getCurrentStateFromStore()

    getCurrentStateFromStore() {
        return {
            config: UhaulStore.getState().FlexReducer.config,
            taskContexts: UhaulStore.getState().UhaulReducer.currentTaskContext,
            customerDataList: UhaulStore.getState().UhaulReducer.customerDataList
        }
    }

    updateStateFromStore = () => {
        const currentState = this.getCurrentStateFromStore();

        if (this.state !== currentState) {
            this.setState(currentState);
        }
    }

    componentDidMount() {
        this.unsubscribeStore = UhaulStore.subscribe(this.updateStateFromStore);
    }
    
    componentWillUnmount() {
        this.unsubscribeStore();
    }

    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({
            hasError: true,
            error: error,
            errorInfo: info
        });
        // You can also log the error to an error reporting service
        // logErrorToMyService(error, info);
    }

    render() {
        try {
            const customerDataList = UhaulStore.getState().UhaulReducer.customerDataList;
            
            if(!customerDataList || customerDataList?.length <= 0 || (!customerDataList?.find(x => (x.SearchTerm && x.SearchTerm != "") || (x.Exception && x.Exception != "")))){
                return (<Box className="Caption">
                    <Text>
                        Loading Customer Data...
                    </Text> 
                </Box>)
            }
            else if(customerDataList?.find(x => x.Exception && x.Exception != "")) {
                return (<Box className="RedCaption">
                    <Text>
                        {(customerDataList[0] && customerDataList[0].Exception ? customerDataList[0].Exception : "There was an error with retrieving customer data. Please refresh this page.")}
                    </Text>
                </Box>)
            }
            else if (customerDataList?.length > 0) {
                var searchTerm = GetSearchTerm(this.props);
                var foundCustomer = customerDataList.find(x => x.SearchTerm === searchTerm); 
                
                if(foundCustomer){ 
                var result = foundCustomer.CustomerOrder, transResult = foundCustomer.TransactionSummary;
                
                    return (
                    <Box id="divSidebar">
                        <Box className="data_section">
                            <Box className="row">
                                <Box className="columns large-12">
                                    <Text as="h3" marginBottom="space10">
                                        {result && result.Customer && result.Customer.FirstName ? result.Customer.FirstName + ' ' + result.Customer.LastName : "N/A"}
                                    </Text>
                                </Box>
                            </Box>
                            <Box className="row">
                                <Box className="columns large-12"> 
                                    <Text as="span">
                                        Total Transactions: 
                                        <Text as="strong">{transResult && transResult.TransactionCount ? transResult.TransactionCount : "..."}</Text>
                                    </Text>
                                    <br /> 
                                </Box>
                            </Box>
                            <Box className="row">
                                <Box className="columns large-12"> 
                                    <Text as="span">
                                        Total Amount: 
                                        $<Text as="strong">{transResult && transResult.TransactionAmount ? transResult.TransactionAmount : "..."}</Text>
                                    </Text>
                                </Box>
                            </Box>
                        </Box>
                        <Box className="row">
                            <Box className="columns large-12">
                                <Box className="data_section">
                                    <Box className="row">
                                        <Box className="columns large-12">
                                            <Text as="h3" marginBottom="space10">Contact Information</Text> 
                                        </Box>
                                    </Box>
                                    <Box className="row">
                                        <Box className="columns large-12">
                                            <Text as="p">
                                                <Text as="strong">Phone: </Text> 
                                                {result && result.ContactInfo && result.ContactInfo.Data && result.ContactInfo.Data.PrimaryPhone ? result.ContactInfo.Data.PrimaryPhone.PhoneNumber : "N/A"}
                                            </Text>
                                        </Box>
                                    </Box>
                                    <Box className="row">
                                        <Box className="columns large-12 wordWrap"> 
                                            <Text as="p">
                                                <Text as="strong">Email: </Text> 
                                                {result && result.ContactInfo && result.ContactInfo.Data && result.ContactInfo.Data.PrimaryEmail ? result.ContactInfo.Data.PrimaryEmail.Email : "N/A"}
                                            </Text>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                        <Box className="data_section">
                            <Box className="row">
                                <Box className="columns large-12">
                                    <Text as="h3" marginBottom="space10">Social Media</Text>
                                </Box>
                            </Box>
                            <Box className="row">
                                <Box className="columns large-12">
                                    {result && result.Customer && result.Customer.SocialMediaHandles && result.Customer.SocialMediaHandles.length > 0 ? result.Customer.SocialMediaHandles[0]["Handle"] : "None available"}
                                </Box>
                            </Box>
                        </Box>
                        <Box className="data_section">
                            <Box className="row">
                                <Box className="columns large-12">
                                    <Text as="h3" marginBottom="space10">Address Information</Text> 
                                </Box>
                            </Box>
                            <Box className="row">
                                <Box className="columns large-12"> <Text as="strong">Billing Address:</Text>
                                    <br />
                                    {result && result.AddressesCategorized && result.AddressesCategorized.Data && result.AddressesCategorized.Data.BillingAddress && result.AddressesCategorized.Data.BillingAddress.length > 0 && result.AddressesCategorized.Data.BillingAddress[0] ? result.AddressesCategorized.Data.BillingAddress[0].StreetAddress : "N/A"}
                                    <br />{
                                    result && result.AddressesCategorized && result.AddressesCategorized && result.AddressesCategorized.Data && result.AddressesCategorized.Data.BillingAddress && result.AddressesCategorized.Data.BillingAddress.length > 0 ? (result.AddressesCategorized.Data.BillingAddress[0].City ? result.AddressesCategorized.Data.BillingAddress[0].City : "N/A") + ", " + result.AddressesCategorized.Data.BillingAddress[0].StateProvinceCode + " " + result.AddressesCategorized.Data.BillingAddress[0].ZipCode : "N/A"}
                                </Box>
                            </Box>
                        </Box>
                    </Box>)
                }
                else {
                    return <Box className="Caption">Customer could not be found.</Box>
                }
            }
        }
        catch(e){
            ExceptionLogger(window.appConfig.getLiveChatApi(), ec, "render", "Error with rendering CMGTCustomerInfo component", null, "")         
        }
        
        return (<Box className="Caption">
            <Text>Unable to display customer info.</Text>
        </Box>)
    }
}

const mapStateToProps = (store) => {
    return {
        config: store.FlexReducer.config,
        taskContexts: store.UhaulReducer.currentTaskContext,
        customerDataList: store.UhaulReducer.customerDataList
    };
};

export default connect(
    mapStateToProps,
    { updateCustomerDataList }
)(CMGTCustomerInfo);
